export const queryParamsMixin = {
  methods: {
    updateQueryParams(params) {
      const query = { ...this.$route.query };
      for (const key in params) {
        if (!params[key]) {
          delete query[key];
        } else {
          query[key] = params[key];
        }
      }
      this.$router.push({ query });
    }
  }
};
